import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { getPurchaseHistorySelector } from '@patrianna-payments/shared-store/payments/store/selectors'
import type { PurchaseItem } from '@patrianna-payments/shared-store/payments/types/openApiModels/PurchaseItem'
import format from 'date-fns/format'

import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter'
import TransactionName from 'pageContainers/TransactionsPage/components/PaymentsTab/components/TransactionName'
import TransactionTitle from 'pageContainers/TransactionsPage/components/PaymentsTab/components/TransactionTitle'
import TransactionItem from 'pageContainers/TransactionsPage/components/TransactionItem'
import redeemFlowContent from 'prismic-translates/redeem-flow-content.json'
import content from 'prismic-translates/transactions-history-page.json'
import { useAppSelector } from 'store/hooks'

import TransactionStatus from '../TransactionStatus'

const t = getTranslationFromJson([content, redeemFlowContent])

const getDate = (date: string) =>
  date ? `${t('date')} ${format(new Date(date), `dd MMMM, yyyy '${t('at_word')}' hh:mm a`)}` : ''

export default function TransactionItems() {
  const { purchases = [] } = useAppSelector(getPurchaseHistorySelector)

  const { currencyFormatter } = useCurrencyFormatter()

  return purchases?.map(({ transactionId, dateTime, method, balanceChange, price, internalStatus }: PurchaseItem) => (
    <TransactionItem
      key={transactionId}
      title={<TransactionTitle balanceChange={balanceChange} />}
      amount={currencyFormatter(Number(price?.[0]?.amount))}
      date={getDate(dateTime)}
      transactionName={<TransactionName {...method} />}
      transactionId={`${t('payment_id')}: ${transactionId}`}
      status={<TransactionStatus status={internalStatus} />}
    />
  ))
}
